module.exports = __webpack_public_path__ + "img/ic_map_hotel_label_1_stars.abc2e90f.svg";